// extracted by mini-css-extract-plugin
var _1 = "TBaJxxvdBl";
var _2 = "iv7oHPdK2x";
var _3 = "Fz674Lc3iF";
export { _1 as "fieldSet", _2 as "form", _3 as "legend" }
